import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  OverlayTrigger,
  Tooltip
} from 'react-bootstrap';
import { Popup } from '../Popup/popup';
import { CheckBoxSingle } from '../../components/checkboxes/check-box-single';

export class ChangeColumn extends Component {
  static propTypes = {
    columnList: PropTypes.array,
    except: PropTypes.array,
    onChangeColumn: PropTypes.func,
    settingColumn: PropTypes.array
  }

  static contextTypes = {
    t: PropTypes.func
  }

  constructor(props) {
    super(props);
    this.defaultSelected = [];
    if (props.settingColumn.length) {
      this.defaultSelected = props.settingColumn;
    } else {
      this.props.columnList.map(column => {
        if (((this.props.except && this.props.except.indexOf(column.field) === -1) || !this.props.except) && column.field !== '' && !column.hidden) {
          this.defaultSelected.push(column.field);
        }
      });
    }
    this.state = {
      isDisplayPopupSelect: false,
      selectedColumns: this.defaultSelected
    };
  }

  componentDidMount() {
    window.addEventListener('click', (e) => {
      if (document.getElementById('s1-popup') && document.getElementById('s1-popup').contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (document.getElementById('popup-button') && document.getElementById('popup-button').contains(e.target)) {
          // clicked in box
        } else {
          if (this.state.isDisplayPopupSelect) {
            this.setState({isDisplayPopupSelect: false});
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.settingColumn.length) {
      this.setState({ selectedColumns: nextProps.settingColumn });
    }
  }

  toolTip() {
    return (
      <Tooltip className='in tooltip-siteone' id='tooltip-change-column'>
        <span>Columns</span>
      </Tooltip>
    );
  }

  toggleClickButtonChangeColumn = () => {
    this.setState({ isDisplayPopupSelect: !this.state.isDisplayPopupSelect });
  }

  onChecked = (field) => {
    const newSelectedColumns = [...this.state.selectedColumns];
    const index = newSelectedColumns.indexOf(field);
    if (index !== -1) {
      newSelectedColumns.splice(index, 1);
    } else {
      newSelectedColumns.push(field);
    }
    this.setState({
      selectedColumns: newSelectedColumns
    }, () => {
      const newColumnProp = [...this.props.columnList];
      newColumnProp.map(column => {
        if ((
          (this.props.except && this.props.except.indexOf(column.field) === -1) ||
            !this.props.except) && column.field !== '') {
          if (this.state.selectedColumns.indexOf(column.field) === -1) {
            column.hidden = true;
          } else {
            column.hidden = false;
          }
        }
      });
      this.props.onChangeColumn(newColumnProp, this.state.selectedColumns);
    });
  }

  renderPopupSelect = () => {
    const popupStyle = {
      padding: 15,
      width: 'auto',
      maxWidth: 300,
      minWidth: 210,
      position: 'absolute',
      left: 110
    };
    if (this.state.isDisplayPopupSelect) {
      return <Popup ref={(ref) => { this.popup = ref; }} styles={popupStyle}>
        <div className='column-select-list-wrapper'>
          <ul>
            {this.props.columnList.map((column, index) => {
              if ((
                (this.props.except && this.props.except.indexOf(column.field) === -1) ||
                  !this.props.except) && column.field !== '') {
                return <li key={index}>
                  <CheckBoxSingle
                    checked={this.state.selectedColumns.indexOf(column.field) !== -1}
                    ref={c => { this.check = c; }}
                    name={column.header}
                    label={column.header}
                    className='checkbox-default'
                    onChecked={() => this.onChecked(column.field)}
                    style={{margin: 0, textOverflow: 'ellipsis', overflow: 'hidden'}}
                  />
                </li> ;
              }
              return null;
            })}
          </ul>
        </div>
      </Popup>;
    } else {
      return null;
    }
  }

  render() {
    return <div className='change-column-box'>
      <OverlayTrigger placement='bottom' overlay={this.toolTip()}>
        <button className='change-column-btn icon-column-ic' id='popup-button' onClick={this.toggleClickButtonChangeColumn}
          style={this.state.isDisplayPopupSelect ? {background: '#ebecf0'} : {}}>
          <div className='change-column-img' />
        </button>
      </OverlayTrigger>
      {this.renderPopupSelect()}

    </div>;
  }
}



// WEBPACK FOOTER //
// ./src/components/change-column/index.js